import React from 'react';
import './iframe.css';

const Iframe = ({ source }) => {

    if (!source) {
        return <div>Loading...</div>;
    }

    const src = source;     
    return (
        <div className="frame">
            
                <iframe className = "frame"title="Global visualization"src={src}loading="lazy"></iframe>
            
        </div>
    );
};

export default Iframe;